import { render, staticRenderFns } from "./ContentBasicInfo.vue?vue&type=template&id=c8a7c608&scoped=true&"
import script from "./ContentBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ContentBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContentBasicInfo.vue?vue&type=style&index=0&id=c8a7c608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a7c608",
  null
  
)

export default component.exports